import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class SummaryCommentService extends BaseService {
  constructor() {
    super(constants.ADD_SUMMARY_COMMENT, 'SummaryCommentService');
  }

  handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    return this.getClient('aiadmin').post(`/chatutility/summary/comment`, payload, { headers });
  }

  handleResponse(response) {
    const { data, status } = response;
    if (status === 200 && data) {
      const notification = {
        open: true,
        type: 'success',
        message: 'Comment added successfully'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);

      Framework.getStoreRegistry().getStore('chatgptSummaryUtility').setSummaryCommentSuccess();
    } else {
      const notification = {
        open: true,
        type: 'error',
        message: 'Failed to add comment'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      } else if (status === 400 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message || 'Bad Request',
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
